/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Prompt_OptimizationInputs */

const en_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt optimization`)
};

const ar_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحسين الأوامر`)
};

const bn_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রম্পট অপটিমাইজেশন`)
};

const de_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnelle Optimierung`)
};

const es_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimización rápida`)
};

const fr_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optimisation rapide`)
};

const pt_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otimização de prompt`)
};

const zh_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示优化`)
};

const tr_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstemi optimizasyonu`)
};

const ru_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оперативная оптимизация`)
};

const pl_svchip_prompt_optimization = /** @type {(inputs: Svchip_Prompt_OptimizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybka optymalizacja`)
};

/**
* | output |
* | --- |
* | "Prompt optimization" |
*
* @param {Svchip_Prompt_OptimizationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_prompt_optimization = /** @type {((inputs?: Svchip_Prompt_OptimizationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Prompt_OptimizationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_prompt_optimization(inputs)
	if (locale === "bn") return bn_svchip_prompt_optimization(inputs)
	if (locale === "de") return de_svchip_prompt_optimization(inputs)
	if (locale === "es") return es_svchip_prompt_optimization(inputs)
	if (locale === "fr") return fr_svchip_prompt_optimization(inputs)
	if (locale === "pt") return pt_svchip_prompt_optimization(inputs)
	if (locale === "zh") return zh_svchip_prompt_optimization(inputs)
	if (locale === "tr") return tr_svchip_prompt_optimization(inputs)
	if (locale === "ru") return ru_svchip_prompt_optimization(inputs)
	if (locale === "pl") return pl_svchip_prompt_optimization(inputs)
	return en_svchip_prompt_optimization(inputs)
});